export const EXCLUSION_TYPES = {
  STUDENT: 'Student',
  GROUP: 'Group',
  GRADE: 'Grade',
}